// extracted by mini-css-extract-plugin
module.exports = {"button":"ItemAction_button__1jWR_","icon":"ItemAction_icon__2X3Fm","desc":"ItemAction_desc__24MVf"};